import HotelSchema from './HotelSchema';
import {
  HotelContentSchema,
  RoomSchema,
  RateSchema,
} from './HotelDetailSchema';
import FlightsHotelSchema from './FlightsHotelSchema';
import HotelBookingSchema from './HotelBookingSchema';

export {
  HotelSchema,
  HotelContentSchema,
  RoomSchema,
  RateSchema,
  FlightsHotelSchema,
  HotelBookingSchema,
};
